export default "__VITE_ASSET__aXbWqtZX__"